import { createContext } from 'react';
import type { BlogPostSummary } from '@wanderlust/shared';

export interface HomeDataContextType {
  /**
   * Latest posts for the homepage blog band, supplied by the prerender build.
   * `null` on the client, which reads the same posts back out of the injected
   * prerender data script instead.
   */
  posts: BlogPostSummary[] | null;
}

export const HomeDataContext = createContext<HomeDataContextType>({
  posts: null,
});
